/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wrapped_Strength_Empty_BodyInputs */

const en_us2_wrapped_strength_empty_body = /** @type {(inputs: Wrapped_Strength_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log load and reps on your sets and your estimated strength shows up here.`)
};

const pt_br2_wrapped_strength_empty_body = /** @type {(inputs: Wrapped_Strength_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registre carga e repetições nas séries e a sua força estimada aparece aqui.`)
};

const es_419_wrapped_strength_empty_body = /** @type {(inputs: Wrapped_Strength_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registra peso y repeticiones en tus series y tu fuerza estimada aparece aquí.`)
};

const pt_pt2_wrapped_strength_empty_body = /** @type {(inputs: Wrapped_Strength_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regista a carga e as repetições nas séries e a tua força estimada aparece aqui.`)
};

const fr_fr2_wrapped_strength_empty_body = /** @type {(inputs: Wrapped_Strength_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note la charge et les répétitions de tes séries et ta force estimée s'affichera ici.`)
};

const de_de2_wrapped_strength_empty_body = /** @type {(inputs: Wrapped_Strength_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trag Gewicht und Wiederholungen bei deinen Sätzen ein, dann erscheint deine geschätzte Kraft hier.`)
};

const it_it2_wrapped_strength_empty_body = /** @type {(inputs: Wrapped_Strength_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registra carico e ripetizioni nelle serie e la tua forza stimata comparirà qui.`)
};

/**
* | output |
* | --- |
* | "Log load and reps on your sets and your estimated strength shows up here." |
*
* @param {Wrapped_Strength_Empty_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_strength_empty_body = /** @type {((inputs?: Wrapped_Strength_Empty_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Strength_Empty_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_strength_empty_body(inputs)
	if (locale === "es-419") return es_419_wrapped_strength_empty_body(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_strength_empty_body(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_strength_empty_body(inputs)
	if (locale === "de-DE") return de_de2_wrapped_strength_empty_body(inputs)
	if (locale === "it-IT") return it_it2_wrapped_strength_empty_body(inputs)
	return en_us2_wrapped_strength_empty_body(inputs)
});
export { wrapped_strength_empty_body as "wrapped.strength_empty_body" }